import { createAction } from '@reduxjs/toolkit';
import { Part, Vehicle } from '../vehicles/actions';

export interface DeliveryResponse {
    id?: number;
    delivery_order: string;
    delivery_company: string;
    delivery_pickup_date: string | null;
    delivery_est_date: string | null;
    search_str: string;
    parts_delivered: number;
    parts_total: number;
    parts: Part[];
    note?: string;
    vehicle?: Vehicle;
}

export const listPartsRequest = createAction<{filters: string, part_fields: string, excludes: string, save_as?: string}>('parts/listRequest');
export const listPartsSuccess = createAction<{data: Part[], save_as: string}>('parts/listSuccess');
export const listPartsFailure = createAction<string>('parts/listFailure');

export const getPartRequest = createAction<{id: number, part_fields: string}>('parts/getRequest');
export const setPartRequest = createAction<Part|null>('parts/setRequest');
export const getPartSuccess = createAction<Part|null>('parts/getSuccess');
export const getPartFailure = createAction<string>('parts/getFailure');

export const updatePartsRequest = createAction<{parts: Part[], update_fields: string[], part_fields?: string, save_as?: string}>('parts/updateRequest');
export const updatePartsSuccess = createAction<{data: Part[], save_as: string}>('parts/updateSuccess');
export const updatePartsFailure = createAction<string>('parts/updateFailure');

export const listPartsDeliveryRequest = createAction<{date_from?: string, date_to?: string}>('parts/listDeliveryRequest');
export const listPartsDeliverySuccess = createAction<Part[]>('parts/listDeliverySuccess');
export const listPartsDeliveryFailure = createAction<string>('parts/listDeliveryFailure');

export const resetErrorRequest = createAction('parts/resetErrorRequest');
